/**
 * Typed access to the build-time environment.
 *
 * Only VITE_-prefixed variables are inlined into the bundle by Vite. Everything
 * here is therefore PUBLIC — it ships to the browser and is readable by anyone.
 * Nothing secret belongs in this file or in any .env the frontend reads.
 */
interface AppEnv {
  readonly apiBaseUrl: string;
  readonly appName: string;
  readonly isProduction: boolean;
  readonly streamer: StreamerConfig;
}

/**
 * The person whose site this is.
 *
 * Configuration, deliberately — not a module and not a database table. There is
 * exactly ONE of these and it changes about as often as the logo does, so a
 * schema, an editor screen and a migration would all be machinery in service of
 * a single row. CLAUDE.md is explicit that inventing a module is the owner's
 * call, and this needs none.
 *
 * Everything here is VITE_-prefixed and therefore PUBLIC — which is correct, as
 * every value is already on the person's public profiles.
 */
interface StreamerConfig {
  readonly name: string;
  readonly bio: string;
  /** Public path or absolute URL. Empty hides the portrait rather than breaking it. */
  readonly avatarUrl: string;
  readonly kickUrl: string;
  /**
   * Whether to show the LIVE badge.
   *
   * A flag, not a live check. Kick's channel status is one API call away, but it
   * is an OUTBOUND integration with its own failure and caching story — and a
   * badge that says LIVE while the stream is off is worse than no badge. Left as
   * a switch the owner controls until that call is worth building.
   */
  readonly isLive: boolean;
  readonly socials: Readonly<Record<'kick' | 'x' | 'instagram' | 'youtube' | 'telegram', string>>;
}

export const env: AppEnv = {
  // Empty means "same origin": in dev the Vite proxy forwards /api to the .NET
  // host, and in production the CDN or reverse proxy does the same.
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '',
  appName: import.meta.env.VITE_APP_NAME ?? 'GeeFamily',
  isProduction: import.meta.env.PROD,

  streamer: {
    name: import.meta.env.VITE_STREAMER_NAME ?? 'Gee',
    bio:
      import.meta.env.VITE_STREAMER_BIO ??
      "Aileye hoş geldin! Kick'te tam zamanlı iGaming yayıncısıyım. Büyük kazançları, yüksek riskleri ve birlikte en iyi topluluğu kurmayı seviyorum.",
    avatarUrl: import.meta.env.VITE_STREAMER_AVATAR ?? '',
    kickUrl: import.meta.env.VITE_STREAMER_KICK ?? '',
    // Any value but an explicit "true" leaves the badge off. A LIVE badge that
    // is on by default would be a lie on the day the site ships.
    isLive: import.meta.env.VITE_STREAMER_LIVE === 'true',
    socials: {
      kick: import.meta.env.VITE_STREAMER_KICK ?? '',
      x: import.meta.env.VITE_STREAMER_X ?? '',
      instagram: import.meta.env.VITE_STREAMER_INSTAGRAM ?? '',
      youtube: import.meta.env.VITE_STREAMER_YOUTUBE ?? '',
      telegram: import.meta.env.VITE_STREAMER_TELEGRAM ?? '',
    },
  },
};
